<template>
	<div>
		<svg width="44px" height="44px" viewBox="0 0 44 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
			<g id="Member_directory" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g>
					<rect id="bg-tabbar-icon" x="0" y="0" width="44" height="44"></rect>
					<g id="ico-member-directory" transform="translate(0, 3.52)" :fill="color" fill-rule="nonzero">
						<path d="M44,9.24 L44,32.34 C44,34.881 42.02,36.96 39.6,36.96 L4.4,36.96 C1.98,36.96 0,34.881 0,32.34 L0.022,4.62 C0.022,2.079 1.98,0 4.4,0 L17.6,0 L22,4.62 L39.6,4.62 C42.02,4.62 44,6.699 44,9.24 Z M33,16.17 C33,13.629 31.02,11.55 28.6,11.55 C26.18,11.55 24.2,13.629 24.2,16.17 C24.2,18.711 26.18,20.79 28.6,20.79 C31.02,20.79 33,18.711 33,16.17 Z M19.8,30.03 L37.4,30.03 L37.4,27.72 C37.4,24.6477 31.526,23.1 28.6,23.1 C25.674,23.1 19.8,24.6477 19.8,27.72 L19.8,30.03 Z" id="path-1"></path>
					</g>
				</g>
			</g>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgBank',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
	},
};
</script>

<style scoped>

</style>